export default "__VITE_ASSET__BKMoi4wQ__"